import isotype from "@/assets/isotype.png";
import { Button } from "@/components/ui/button";
import { useCurrentEnrollment } from "@/hooks/current-enrollment.hook";
import { cn } from "@/lib/utils";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { parseISO } from "date-fns";
import { format } from "date-fns/format";
import { Document } from "iconsax-react";
import { useAtomValue } from "jotai";
import { motion } from "motion/react";
import { FC, HTMLAttributes } from "react";
import { Link } from "react-router-dom";

type EnrollmentBannerProps = HTMLAttributes<HTMLDivElement>;

const EnrollmentBanner: FC<EnrollmentBannerProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const {
    canEnroll,
    currentApplicationIsLoading,
    enrollmentlMilestone,
    edition,
  } = useCurrentEnrollment(editionId);

  // Bail early if enrollment is not open or the user is already enrolled
  if (currentApplicationIsLoading || !canEnroll || !edition) {
    return null;
  }

  const startDate = enrollmentlMilestone
    ? format(parseISO(enrollmentlMilestone.startDate), "dd MMMM yyyy")
    : null;

  const endDate = enrollmentlMilestone
    ? format(parseISO(enrollmentlMilestone.endDate), "dd MMMM yyyy")
    : null;

  return (
    <motion.div
      className={cn(
        "flex flex-col gap-4 rounded-xl bg-[#262452] px-12 py-8 text-white lg:flex-row lg:items-center",
        props.className,
      )}
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <img
        className="hidden shrink-0 lg:block"
        src={isotype}
        width={78}
        height={78}
      />

      <div className="grow">
        <h3 className="my-2 text-2xl">Inscripciones abiertas</h3>

        <p className="text-lg">
          ¡Reafirma tu compromiso! La nueva edición{" "}
          {edition.type === "REGULAR" ? edition.year : edition.name} iniciará
          pronto, inscríbete ahora y continúa impulsando tu impacto sostenible.
        </p>

        {enrollmentlMilestone && (
          <p className="my-1 text-base text-[#9491CF]">
            <strong>
              Plazo: {startDate} - {endDate}
            </strong>
          </p>
        )}
      </div>

      <Button variant="secondary" className="self-start lg:self-auto" asChild>
        <Link to={`/enroll/${editionId}`}>
          <Document /> Inscribirme
        </Link>
      </Button>
    </motion.div>
  );
};

export default EnrollmentBanner;
